import { __CAPTCHA_GET_URL__,__FTP_URL__,__COMPOSITE1__ ,__COMPOSITE2__,__COMPOSITE3__} from "../../../env/config"

export const API_URLS = {
  CAPTCHA_GET_URL:__CAPTCHA_GET_URL__,
  FTP_URL:__FTP_URL__,
  COMPOSITE1:__COMPOSITE1__,
  COMPOSITE2:__COMPOSITE2__,
  COMPOSITE3:__COMPOSITE3__
}

